import DefaultIndividualsFeatureList from './features/defaultIndividualsFeatureList';
import AdvantageAnnualFeatureList from './features/advantageAnnualFeatureList';
import PremierAnnualFeatureList from './features/premierAnnualFeatureList';
import FeatureRules from './rules/featureRules';
import summaryFeaturesTransformer from './summaryFeaturesTransformer';

export default summaryFeaturesTransformer(
  [...DefaultIndividualsFeatureList, ...AdvantageAnnualFeatureList, ...PremierAnnualFeatureList],
  {
    ...FeatureRules,
    // Add feature rule overrides below
    // create_limit: () => formatSummaryFeature('survey_create_limit'),
  }
);
